import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../contexts/auth";

const token = sessionStorage.getItem('token');

//const BASE_URL = "https://telemetriacargavivateste.everlink.com.br/api/";
const BASE_URL = "https://telemetriacargaviva.everlink.com.br/api/";
//const BASE_URL = "http://localhost:5022/api/";

const defaultOptions = {
    baseURL: BASE_URL,
    headers: {
        "Authorization": `Bearer ${token}`,
    },
};

const axiosConnection = axios.create(defaultOptions);

axiosConnection.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        const { logout } = useContext(AuthContext);
        sessionStorage.removeItem('valueKanban');
        sessionStorage.removeItem('updateKanban');
        sessionStorage.removeItem('valueKanbanLabel');
        sessionStorage.removeItem('intervalUpatedCards');
        sessionStorage.removeItem('id_update_chart_farm');
        sessionStorage.removeItem('id_interval_sensorChart');
        sessionStorage.removeItem('valueTypeOperationCards');
        sessionStorage.removeItem('valueTypeOperationKanban');
        sessionStorage.removeItem('typeOperationUser');
        logout();
    }

    return Promise.reject(error);
});

export class ApiService {
    get(path, data) {
        return axiosConnection.get(path, data);
    }

    getCommand(path, id, command) {
        return axiosConnection.get(`${path}/trackerparam/${id}/${command}`);
    }

    getVehiclesByBlueprint(path, id, list) {
        const queryString = list.map(b => `blueprints=${encodeURIComponent(b)}`).join("&");
        return axiosConnection.get(`${path}/getVehiclesByBlueprint/${id}?${queryString}`);
    }

    getByIds(path, ids) {
        const queryString = ids.map(b => `devicesId=${encodeURIComponent(b)}`).join("&");
        return axiosConnection.get(`${path}?${queryString}`);
    }

    getById(path, id) {
        return axiosConnection.get(path + '/' + id);
    }

    post(path, data) {
        return axiosConnection.post(path, data);
    }

    put(path, data) {
        return axiosConnection.put(path, data);
    }

    patch(path) {
        return axiosConnection.patch(path);
    }

    delete(path, id) {
        return axiosConnection.delete(path + '/' + id);
    }

    postUndo(path, id) {
        return axiosConnection.post(path + '/' + id);
    }

    async postFile(path, datas) {
        return axios({
            method: 'post',
            url: BASE_URL.substring(0, BASE_URL.length - 1) + path, //API url
            data: JSON.stringify(datas), // Buffer
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        });
    }

    async saveFile(path, file) {
        const formData = new FormData();
        formData.append("file", file);
        try {
            const response = await axios({
                method: 'post',
                url: BASE_URL.substring(0, BASE_URL.length - 1) + path,
                data: formData,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
        }
    }

    SendCommand(path, comando) {
        return axios({
            method: 'post',
            url: BASE_URL.substring(0, BASE_URL.length - 1) + path, //API url
            data: JSON.stringify(comando), // Buffer
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        });
    }

    sendParam(path, list) {

        return axios({
            method: 'post',
            url: BASE_URL.substring(0, BASE_URL.length - 1) + path, //API url
            data: JSON.stringify(list), // Buffer
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        });
    }
}